import { BatchLookupStage, BatchLookupValue, LookupValues, Mode, SearchFunc } from '../types/ui'
import { JaneProductApiResponse, ProductForm } from '../types/products'

export const RESET_BATCH_DATA = '[command] ui/RESET_BATCH_DATA'
export const RESET_LOOKUP = '[command] ui/RESET_LOOKUP'
export const BATCH_LIST_MOVE_UP = '[command] ui/BATCH_LIST_MOVE_UP'
export const BATCH_LIST_MOVE_DOWN = '[command] ui/BATCH_LIST_MOVE_DOWN'
export const SET_LOOKUP_VALUES = '[document] ui/SET_LOOKUP_VALUES'
export const SET_IS_LOADING = '[document] ui/SET_IS_LOADING'
export const SET_DIRECT_URL = '[document] ui/SET_DIRECT_URL'
export const SET_IS_POSTING_PRODUCT = '[document] ui/SET_IS_POSTING_PRODUCT'
export const SET_GETTING_PRODUCT_ID = '[document] ui/SET_GETTING_PRODUCT_ID'
export const SET_LAST_ACTION = '[document] ui/SET_LAST_ACTION'
export const SET_CLIPBOARD_PRODUCT = '[document] ui/SET_CLIPBOARD_PRODUCT'
export const SET_INITIAL_PRODUCT_VALUES = '[document] ui/SET_INITIAL_PRODUCT_VALUES'
export const SET_CURRENT_BATCH_ID = '[document] ui/SET_CURRENT_BATCH_ID'
export const UPDATE_BATCH_PROGRESS = '[document] ui/UPDATE_BATCH_PROGRESS'
export const SET_BATCH_LOOKUP_VALUES = '[document] ui/SET_BATCH_LOOKUP_VALUES'
export const SET_BATCH_LOOKUP_VALUES_ALIAS = '[document] ui/SET_BATCH_LOOKUP_VALUES_ALIAS'
export const SET_BATCH_LOOKUP_STAGE = '[document] ui/SET_BATCH_LOOKUP_STAGE'
export const SET_BATCH_PROGRESS_ERROR = '[document] ui/SET_BATCH_PROGRESS_ERROR'
export const SET_BATCH_LOOKUP_TIMEOUTS = '[document] ui/SET_BATCH_LOOKUP_TIMEOUTS'
export const SET_SEARCH_FUNC = '[document] ui/SET_SEARCH_FUNC'
export const SET_ENABLE_DEEP_MATCHER = '[document] ui/SET_ENABLE_DEEP_MATCHER'
export const OAUTH_LOGIN_REDIRECT = `[document] ui/OAUTH_LOGIN_REDIRECT`
export const SET_CURRENT_USER = '[document] ui/SET_CURRENT_USER'
export const ADD_BULK_EDIT_SUCCESS = '[document] ui/ADD_BULK_EDIT_SUCCESS'
export const ADD_BULK_EDIT_ERROR = '[document] ui/ADD_BULK_EDIT_ERROR'
export const RESET_BULK_EDIT_RESULTS = '[document] ui/RESET_BULK_EDIT_RESULTS'

export const addBulkEditSuccess = (payload: { id: number }) => ({
  type: ADD_BULK_EDIT_SUCCESS,
  payload,
})

export const addBulkEditError = (payload: { id: number; message: string }) => ({
  type: ADD_BULK_EDIT_ERROR,
  payload,
})

export const resetBulkEditResults = () => ({
  type: RESET_BULK_EDIT_RESULTS,
})

export const setLookupValues = (
  payload: {
    values: LookupValues
    batchId?: string
  } | null
) => ({
  type: SET_LOOKUP_VALUES,
  payload,
})

export const setIsLoading = (payload: { status: boolean }) => ({
  type: SET_IS_LOADING,
  payload,
})

export const setDirectUrl = (payload: { url: string }) => ({
  type: SET_DIRECT_URL,
  payload,
})

export const setIsPostingProduct = (payload: { status: boolean }) => ({
  type: SET_IS_POSTING_PRODUCT,
  payload,
})

export const setGettingProductId = (payload: { productId: string | undefined }) => ({
  type: SET_GETTING_PRODUCT_ID,
  payload,
})

export const setLastAction = (payload: { mode: Mode }) => ({
  type: SET_LAST_ACTION,
  payload,
})

export const setClipboardProduct = (payload: { product: JaneProductApiResponse }) => ({
  type: SET_CLIPBOARD_PRODUCT,
  payload,
})

export const setInitialProductValues = (
  payload: {
    values: ProductForm | {}
  } | null
) => ({
  type: SET_INITIAL_PRODUCT_VALUES,
  payload,
})

export const setCurrentBatchId = (
  payload: {
    batchId: string | undefined
  } | null
) => ({
  type: SET_CURRENT_BATCH_ID,
  payload,
})

export const updateBatchProgress = (
  payload: {
    batchId: string
    increment: number
  } | null
) => ({
  type: UPDATE_BATCH_PROGRESS,
  payload,
})

export const setBatchLookupValues = (
  payload: {
    batchLookupValues: BatchLookupValue[]
  } | null
) => ({
  type: SET_BATCH_LOOKUP_VALUES,
  payload,
})

export const setBatchLookupValuesAlias = (payload: {
  batchId: string | undefined
  alias: string
}) => ({
  type: SET_BATCH_LOOKUP_VALUES_ALIAS,
  payload,
})

export const setBatchLookupStage = (payload: { stage: BatchLookupStage }) => ({
  type: SET_BATCH_LOOKUP_STAGE,
  payload,
})

export const setBatchProgressError = (payload: { batchId: string } | null) => ({
  type: SET_BATCH_PROGRESS_ERROR,
  payload,
})

export const setBatchLookupTimeouts = (payload: { timeouts: number[] } | null) => ({
  type: SET_BATCH_LOOKUP_TIMEOUTS,
  payload,
})

export const resetBatchData = () => ({
  type: RESET_BATCH_DATA,
})

export const resetLookup = () => ({
  type: RESET_LOOKUP,
})

export const batchListMoveUp = () => ({
  type: BATCH_LIST_MOVE_UP,
})

export const batchListMoveDown = () => ({
  type: BATCH_LIST_MOVE_DOWN,
})

export const setSearchFunc = (payload: { searchFunc: SearchFunc }) => ({
  type: SET_SEARCH_FUNC,
  payload,
})

export const setEnableDeepMatcher = (payload: { enableDeepMatcher: boolean }) => ({
  type: SET_ENABLE_DEEP_MATCHER,
  payload,
})
